import { IAutoCompletePrefix } from "api/interfaces/search.type";
import { deepEqual } from "./lodash/deepEqual";

export default class PALocalStorage {
  static storage: Storage | { [key: string]: string | undefined };

  static initialize() {
    const defaultStorage = {
      _storage: {} as { [key: string]: string | undefined },

      getItem(key: string): string | null {
        return this._storage[key] || null;
      },

      setItem(key: string, value: string) {
        this._storage[key] = value;
      },

      removeItem(key: string) {
        delete this._storage[key];
      },
    };

    try {
      if (typeof window !== "undefined" && window.localStorage) {
        this.storage = window.localStorage;
      } else {
        throw new Error("localStorage is not available");
      }
    } catch (err) {
      this.storage = defaultStorage;
    }
  }
}

export function getUserChatAgent() {
  return PALocalStorage.storage.getItem("userChatAgent");
}
export function setUserChatAgent(userChatAgent: string) {
  return PALocalStorage.storage.setItem("userChatAgent", userChatAgent);
}

export function getGclid() {
  return PALocalStorage.storage.getItem("gclid");
}

export function setGclid(gclid: string) {
  return PALocalStorage.storage.setItem("gclid", gclid);
}

export function removeGclid() {
  PALocalStorage.storage.removeItem("gclid");
}

export function setSecurityUuid(securityUuid) {
  PALocalStorage.storage.setItem("signifySession", securityUuid);
}

export function getSecurityUuid() {
  const sessionData = PALocalStorage.storage.getItem("signifySession");

  const defaultSession = {
    uuid: undefined,
    timestamp: null,
  };

  if (!sessionData) {
    return defaultSession;
  }

  try {
    const session = JSON.parse(sessionData);
    if (typeof session.uuid === "string" && typeof session.timestamp === "number") {
      return session;
    }
    return defaultSession;
  } catch (error) {
    return defaultSession;
  }
}

export function getLSObject(key: ILSKey, defaultValue?: any) {
  const stringifiedObject = PALocalStorage.storage.getItem(key);
  if (!stringifiedObject) {
    return defaultValue || null;
  }
  return JSON.parse(stringifiedObject);
}

export function setReturnItems(returnItems) {
  PALocalStorage.storage.setItem("returnItems", JSON.stringify(returnItems));
}

export function getIsOneClickCheckout() {
  return PALocalStorage.storage.getItem("isOneClickCheckout");
}

export function setIsOneClickCheckout(isOneClickCheckout?: boolean) {
  if (!isOneClickCheckout) {
    PALocalStorage.storage.removeItem("isOneClickCheckout");
    return;
  }
  PALocalStorage.storage.setItem("isOneClickCheckout", isOneClickCheckout);
}

type ILSKey = "category-scroll-to-product" | "signifySession" | "returnItems" | "recentSearches" | "isBusinessCustomer" | "kl-post-identification-sync" | `showCheckoutOffer-${string}` | "email" | "emailSha";

export function setLSItem(key: ILSKey, value: string) {
  PALocalStorage.storage.setItem(key, value);
}

export function getLSItem(key: ILSKey) {
  return PALocalStorage.storage.getItem(key);
}

export function removeLSItem(key: ILSKey) {
  PALocalStorage.storage.removeItem(key);
}

export function setRecentSearches(suggestion?: IAutoCompletePrefix) {
  if (!suggestion) {
    PALocalStorage.storage.removeItem("recentSearches");
  } else {
    const recentSearchesSuggestions: IAutoCompletePrefix[] = getLSObject("recentSearches", []);

    recentSearchesSuggestions.forEach((_, index) => {
      const updated_ = { ..._ };
      const updatedSuggestion = { ...suggestion };
      delete updated_.highlighted;
      delete updatedSuggestion.highlighted;
      if (deepEqual(updated_, updatedSuggestion)) {
        recentSearchesSuggestions.splice(index, 1);
        return true;
      }
      return false;
    });

    PALocalStorage.storage.setItem("recentSearches", JSON.stringify([{ ...suggestion }, ...recentSearchesSuggestions.slice(0, 3)]));
  }
}
